(function() {
    var container = document.querySelector('.gh-content');
    var tocWrapper = document.querySelector('.toc-wrapper');
    if (!container || !tocWrapper) return;

    var headings = container.querySelectorAll('h2[id], h3[id]');
    if (headings.length < 3) {
        tocWrapper.style.display = 'none';
        return;
    }

    var tocContent = tocWrapper.querySelector('.toc-content');
    var list = document.createElement('ul');
    list.className = 'toc-list';

    headings.forEach(function(h) {
        var li = document.createElement('li');
        li.className = 'toc-item toc-' + h.tagName.toLowerCase();
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        list.appendChild(li);
    });

    tocContent.appendChild(list);

    var toggle = tocWrapper.querySelector('.toc-toggle');
    toggle.addEventListener('click', function() {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        tocContent.classList.toggle('is-open');
    });

    var links = tocContent.querySelectorAll('a');
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                links.forEach(function(l) { l.classList.remove('is-active'); });
                var activeLink = tocContent.querySelector('a[href="#' + entry.target.id + '"]');
                if (activeLink) activeLink.classList.add('is-active');
            }
        });
    }, { rootMargin: '-80px 0px -70% 0px' });

    headings.forEach(function(h) { observer.observe(h); });
})();
